
import { AuthToken } from '@app/interfaces/auth';
import { createAction, props } from '@ngrx/store';

export const loadToken = createAction('[Auth] Load Token');

export const loadTokenSuccess = createAction(
  '[Auth] Load Token Success',
  props<{ token: AuthToken }>()
);

export const loadTokenFailure = createAction(
  '[Auth] Load Token Failure',
  props<{ error: string }>()
);

export const clearToken = createAction('[Auth] Clear Token');